module.exports = __webpack_public_path__ + "media/assets/offerCircle-6238f5b771722efbabcf57e66a972204.png";